/**
 * Product gallery counter: show active image index / total images.
 * Dawn SliderComponent uses scroll-page math that drifts on mobile; we override after it runs.
 */
(function () {
  function getGallerySlides(list) {
    return [...list.children].filter(
      (element) => element.classList.contains('product__media-item') && element.clientWidth > 0
    );
  }

  function syncGalleryCounter(sliderComponent) {
    const list = sliderComponent.querySelector('[id^="Slider-Gallery-"]');
    const totalEl = sliderComponent.querySelector('.slider-counter--total');
    const currentEl = sliderComponent.querySelector('.slider-counter--current');
    if (!list || !totalEl || !currentEl) return;

    const slides = getGallerySlides(list);
    const total = slides.length;
    if (!total) return;

    totalEl.textContent = String(total);

    if (total === 1) {
      currentEl.textContent = '1';
      return;
    }

    const viewportCenter = list.scrollLeft + list.clientWidth / 2;
    let activeIndex = 0;
    let minDistance = Infinity;

    slides.forEach((slide, index) => {
      const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      const distance = Math.abs(slideCenter - viewportCenter);
      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = index;
      }
    });

    currentEl.textContent = String(activeIndex + 1);
  }

  function patchSliderPrototype() {
    if (window._cbdGalleryCounterPatched) return;
    window._cbdGalleryCounterPatched = true;

    customElements.whenDefined('slider-component').then(() => {
      const proto = Object.getPrototypeOf(document.createElement('slider-component'));
      if (!proto?.update) return;

      const originalUpdate = proto.update;
      proto.update = function (...args) {
        originalUpdate.apply(this, args);
        if (this.id?.startsWith('GalleryViewer-')) {
          syncGalleryCounter(this);
        }
      };

      const originalInitPages = proto.initPages;
      proto.initPages = function (...args) {
        originalInitPages.apply(this, args);
        if (this.id?.startsWith('GalleryViewer-')) {
          syncGalleryCounter(this);
        }
      };

      document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(syncGalleryCounter);
    });
  }

  function bindGalleryViewer(sliderComponent) {
    if (!sliderComponent.id?.startsWith('GalleryViewer-') || sliderComponent.dataset.cbdGalleryCounterBound) {
      return;
    }
    sliderComponent.dataset.cbdGalleryCounterBound = 'true';

    const list = sliderComponent.querySelector('[id^="Slider-Gallery-"]');
    if (!list) return;

    const onUpdate = () => syncGalleryCounter(sliderComponent);

    list.addEventListener('scroll', onUpdate, { passive: true });
    list.addEventListener('scrollend', onUpdate, { passive: true });
    window.addEventListener('resize', onUpdate);
    new ResizeObserver(onUpdate).observe(list);

    onUpdate();
  }

  function boot() {
    patchSliderPrototype();
    document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(bindGalleryViewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
